import React from "react";
import { NavLink } from "react-router-dom";
import Chevron from "../../../stories/Components/Buttons/Chevron";
import useBreadCrumbs from "./useBreadCrumbs";

const BreadCrumbs = () => {
  const { breadCrumbs } = useBreadCrumbs();
  return (
    <div className="h-5 text-sm text-gray-200 mb-6">
      {breadCrumbs.length > 1 && (
        <div className="flex">
          {breadCrumbs
            .slice(0, breadCrumbs.length - 1)
            .map(({ breadcrumb, match }, index) => {
              return (
                <NavLink key={match.path} to={match.url}>
                  <div
                    className={`flex items-center ${index !== 0 ? "ml-2" : ""}`}
                  >
                    <Chevron rotate="-180" color="#757575" />
                    <p
                      style={{ fontSize: "16px" }}
                      className="text-gray-650 font-medium ml-2"
                    >
                      {breadcrumb}
                    </p>
                  </div>
                </NavLink>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default BreadCrumbs;
